import type { ImageBlock } from '@botpress/webchat'
import { forwardRef } from 'react'

type Props = ImageBlock
export const ImageRenderer = forwardRef<HTMLImageElement, Props>(({ url, orientation = 'auto', ...props }, ref) => {
  return <img data-orientation={orientation} {...props} src={url} alt="" ref={ref} loading="lazy" />
})
